import React, { memo } from 'react';
import Chart from 'react-apexcharts';

function Pie({ series, labels, colors }) {
  const options = {
    chart: {
      width: 260,
      type: 'pie',
    },
    legend: {
      show: false,
    },
    hover: {
      filter: {
        type: 'none',
      },
    },
    dataLabels: {
      enabled: false,
    },
    tooltip: {
      enabled: true,
      y: {
        formatter: function(value) {
          return value + "%";
        }
      }
    },

    labels: labels,
    colors: colors,
    responsive: [
      {
        breakpoint: 480,
        options: {
          chart: {
            width: 200,
          },
          legend: {
            position: 'bottom',
          },
        },
      },
    ],
  };
  return <Chart options={options} series={series} type="pie" />;
}

export default memo(Pie);
